
import { showSuccessToast, showInfoToast, showWarningToast, showErrorToast } from '@/utils/toastUtils';

export class NotificationToastService {
  static showToast(notification: any) {
    const toastOptions = {
      title: notification.title,
      description: notification.message,
      userAvatar: notification.user_avatar,
      userName: notification.username,
      userId: notification.source_id
    };

    // Show toast based on notification type
    switch (notification.notification_type) {
      case 'match_created':
        showSuccessToast({
          title: notification.title || 'Novo Match!',
          description: notification.message || 'Você tem um novo match!',
          duration: 6000,
          ...toastOptions
        });
        break;
      
      case 'like_received':
        showInfoToast({
          title: notification.title || 'Curtida Recebida',
          description: notification.message || 'Alguém curtiu seu perfil!',
          duration: 5000,
          ...toastOptions
        });
        break;
      
      case 'new_message':
        // Only show if not in the conversation
        if (!window.location.pathname.includes('/chat/')) {
          showInfoToast({
            title: notification.title || 'Nova Mensagem',
            description: notification.message || 'Você recebeu uma nova mensagem!',
            duration: 5000,
            ...toastOptions
          });
        }
        break;

      case 'connection_removed':
        showWarningToast({
          title: notification.title || 'Conexão Removida',
          description: notification.message || 'Uma conexão foi removida.',
          duration: 5000,
          ...toastOptions
        });
        break;

      case 'system_error':
        showErrorToast({
          title: notification.title || 'Erro do Sistema',
          description: notification.message || 'Ocorreu um erro no sistema.',
          duration: 8000,
          ...toastOptions
        });
        break;
      
      default:
        showInfoToast({
          title: notification.title || 'Notificação',
          description: notification.message || 'Você tem uma nova notificação.',
          duration: 4000,
          ...toastOptions
        });
        break;
    }
  }
}
